<template>
  <div>
    <el-divider>{{$t('私有属性')}}</el-divider>
    <el-form-item :label="$t('绑定类型')">
      <l-select
        v-model="data.bindingType"
        :placeholder="$t('请选择')"
        size="mini"
        :options="[
          { label: '关联组件', value: 1 },
          { label: '固定值', value: 2 },
        ]"
        @change="handleCodeTypeChange"
        :clearable="false"
      >
      </l-select>
    </el-form-item>
    <el-form-item
      :label="$t('关联组件')"
      v-if="['qrcode', 'barcode'].includes(data.type) && data.bindingType == 1"
    >
      <l-select
        v-model="data.valueKey"
        :placeholder="$t('请选择')"
        size="mini"
        :options="valueOptions"
        :clearable="false"
      >
      </l-select>
    </el-form-item>
    <el-form-item :label="$t('固定值')" v-if="data.bindingType == 2">
      <el-input v-model="data.default" placeholder="请输入内容(不可为中文)" />
    </el-form-item>
    <el-form-item :label="$t('条码类型')">
      <l-select v-model="data.format" :options="options" :clearable="false" />
    </el-form-item>

    <el-form-item :label="$t('条码宽度')">
      <el-input-number v-model="data.width" :min="1" />
    </el-form-item>

    <el-form-item :label="$t('条码高度')">
      <el-input-number v-model="data.height" :min="1" />
    </el-form-item>

    <el-form-item :label="$t('背景颜色')">
      <l-input-color v-model="data.background" />
    </el-form-item>

    <el-form-item :label="$t('字体颜色')">
      <l-input-color v-model="data.color" />
    </el-form-item>

    <el-form-item :label="$t('文字对齐')">
      <el-radio v-model="data.textAlign" label="left">左边</el-radio>
      <el-radio v-model="data.textAlign" label="center">中间</el-radio>
      <el-radio v-model="data.textAlign" label="right">右边</el-radio>
    </el-form-item>

    <el-form-item :label="$t('文字字体')">
      <el-radio v-model="data.fontOptions" label="">无效果</el-radio>
      <el-radio v-model="data.fontOptions" label="bold">加粗</el-radio>
      <el-radio v-model="data.fontOptions" label="italic">斜体</el-radio>
      <el-radio v-model="data.fontOptions" label="bold italic"
        >加粗+斜体</el-radio
      >
    </el-form-item>

    <el-form-item :label="$t('文字位置')">
      <el-radio v-model="data.textPosition" label="top">上</el-radio>
      <el-radio v-model="data.textPosition" label="bottom">下</el-radio>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "data-barcode",
  props: ["data"],
  inject: ["formDesign"],
  data() {
    return {
      options: [
        {
          value: "CODE128",
          label: "CODE128",
        },
        {
          value: "CODE128A",
          label: "CODE128A",
        },
        {
          value: "CODE128B",
          label: "CODE128B",
        },
        {
          value: "CODE128C",
          label: "CODE128C",
        },
        {
          value: "EAN13",
          label: "EAN13",
        },
        {
          value: "EAN8",
          label: "EAN8",
        },
        {
          value: "EAN5",
          label: "EAN5",
        },
        {
          value: "EAN2",
          label: "EAN2",
        },

        {
          value: "UPC",
          label: "UPC",
        },
        {
          value: "CODE39",
          label: "CODE39",
        },
        {
          value: "ITF",
          label: "ITF",
        },
        {
          value: "MSI10",
          label: "MSI10",
        },
        {
          value: "MSI11",
          label: "MSI11",
        },
        {
          value: "MSI1010",
          label: "MSI1010",
        },
        {
          value: "MSI1110",
          label: "MSI1110",
        },
        {
          value: "pharmacode",
          label: "pharmacode",
        },
        {
          value: "codabar",
          label: "codabar",
        },
      ],
    };
  },
  computed: {
    valueOptions() {
      const res = [];
      const formInfo = this.formDesign.toSaveData();
      if (!this.data.subfield) {
        formInfo.tabList.forEach((tab) => {
          tab.components.forEach((com) => {
            if (
              ![
                "divider",
                "gridtable",
                "card",
                "btn",
                "qrcode",
                "barcode",
                "tableLayout", 'txt', 'img', 'auditLog'
              ].includes(com.type)
            ) {
              res.push({ value: com.prop, label: com.label });
            }
          });
        });
      } else {
        formInfo.tabList.forEach((tab) => {
          tab.components.forEach((com) => {
            if (
              ["gridtable"].includes(com.type) &&
              com.children.findIndex((t) => t.prop == this.data.prop) != -1
            ) {
              com.children.forEach((c) => {
                if (c.prop != this.data.prop) {
                  res.push({ value: c.prop, label: c.label });
                }
              });
            }
          });
        });
      }
      return res;
    },
  },
  methods: {
    handleCodeTypeChange(val) {
      if (!val) return;
      this.data.default = "";
    },
  },
};
</script>